import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import NewApi from "./NewApi";
import { useLanguage } from "../../Translations/LenguageContext";
import ErrorPage from "../../Components/ErrorPage";
import { Dropdown } from "react-bootstrap";
import FormatDateTime from "../../Functions/FormatDate";
import LoadingCubes from "../ViewComponents/LoadingCubes";
import NoDataFoundMex from "../ViewComponents/NoDataFound";
import DeleteRecordModal from "../ViewComponents/DeleteRecordModal";
import EmptyViewOpenModal from "../ViewComponents/EmptyViewOpenModal";

const MainApi = () => {
    const { t } = useLanguage()
    const user_id = sessionStorage.getItem("user_id")
    const [activeFilter, setActiveFilter] = useState("active");
    const [searchQuery, setSearchQuery] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [animateReset, setAnimateReset] = useState(false)
    const [records, setRecords] = useState([])
    const [filteredRecords, setFilteredRecords] = useState([])
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedRecordId, setSelectedRecordId] = useState(null);
    const [apiName, setApiName] = useState("")
    const [showApi, setShowApi] = useState(false)


    const no_data_mex = "No APIs found..."
    const title_empty = "API Keys"
    const subtitle_empty = "API connectors provide seamless access to resources."
    const item = "api"

    const ShowApi = () => {
        setShowApi(true)
    }

    const fetchRecords = async () => {
        setLoading(true)
        try {
            const response = await fetch("https://backend.erioon.com/get_apis", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id }),
            });
            if (response.ok) {
                const result = await response.json();
                const apisData = result.apis || {};
                const recordsArray = Object.values(apisData);

                setRecords(recordsArray);
                setFilteredRecords(recordsArray);
            } else {
                const errorData = await response.json();
                setError(errorData.message || "Failed to load roles.");
            }
        } catch (err) {
            setLoading(false)
            setError("Failed to connect to the server. Please try again later.");
        } finally {
            setTimeout(() => {
                setLoading(false)
            }, 500);
        }
    };

    useEffect(() => {
        if (user_id) {
            fetchRecords();
        } else {
            setError("User ID is missing. Please log in again.");
            setLoading(false);
        }
    }, [user_id]);

    const handleSearch = (event) => {
        const query = event.target.value.toLowerCase();
        setSearchQuery(query);

        if (query.trim() === "") {
            setFilteredRecords(records);
            return;
        }

        const filtered = records.filter((api) => {
            return (
                api._id.toLowerCase().includes(query) ||
                api.name.toLowerCase().includes(query) ||
                FormatDateTime(api.timestamp).toLowerCase().includes(query)
            );
        });

        setFilteredRecords(filtered);
    };

    const resetFilters = () => {
        setSearchQuery("")
        setActiveFilter("active");
        setAnimateReset(true)
        setTimeout(() => {
            setAnimateReset(false)
        }, 1000);
    };


    const handleDeleteClick = (apiId, apiName) => {
        setSelectedRecordId(apiId);
        setApiName(apiName)
        setShowDeleteModal(true);
    };


    if (loading) {
        return <LoadingCubes />;
    } else if (error) {
        return <ErrorPage />;
    } else if (records.length === 0) {
        return <EmptyViewOpenModal fetchRecords={fetchRecords} title={title_empty} subtitle={subtitle_empty} item={item} />
    }


    return (
        <div>
            <div className="work_env_section">
                <div className="header_main_view fade-in">
                    <div className="header_title">
                        <p className="main_view_title">{t.apis.main_title}</p>
                        <p className="main_view_subtitle">{t.apis.main_subtitle}</p>
                        <button className="connect_email_btn" onClick={ShowApi}>
                            <i className="fa-solid fa-plus"></i> {t.create}
                        </button>
                    </div>
                </div>
                <div className="filter_container fade-in">
                    <button
                        className={`filter_btn ${activeFilter === "" ? "clicked_filter" : ""}`}
                        onClick={resetFilters}
                    >
                        <i className={`fa-solid fa-arrows-rotate ${animateReset ? "activated_animation" : ""}`}></i>
                    </button>
                    <div className="filter_input_cont">
                        <i className="fa-solid fa-magnifying-glass"></i>
                        <input
                            className="filter_input"
                            placeholder={t.search}
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                    </div>
                </div>
                <div className="table_container">
                    {filteredRecords.length === 0 ? (
                        <>
                            <NoDataFoundMex message={no_data_mex} />
                        </>
                    ) : (
                        <>
                            {filteredRecords.map((api) => (
                                <div key={api._id} className="api_item fade-in">
                                    <p className="table_name">{api.name}</p>
                                    <p className="table_desc">{FormatDateTime(api.timestamp)}</p>

                                    <div className="table_item_footer">
                                        <Dropdown>
                                            <div className="property_btn_action_toggle">
                                                <Dropdown.Toggle className="custom-dropdown-toggle" as="div">
                                                    <i className="fa-solid fa-ellipsis-vertical"></i>
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className="custom-dropdown-menu">
                                                    <Dropdown.Item
                                                        className="drop_down_item delete"
                                                        onClick={() => handleDeleteClick(api._id, api.name)}
                                                    >
                                                        <i className="fa-solid fa-trash"></i> {t.delete}
                                                    </Dropdown.Item>

                                                </Dropdown.Menu>
                                            </div>
                                        </Dropdown>
                                    </div>
                                </div>
                            ))}
                        </>
                    )}

                </div>

                <NewApi
                    show={showApi}
                    handleClose={() => setShowApi(false)}
                    fetchRecords={fetchRecords}
                />

                <DeleteRecordModal
                    show={showDeleteModal}
                    handleClose={() => setShowDeleteModal(false)}
                    recordObject={records.find((record) => record._id === selectedRecordId)}
                    fetchRecords={fetchRecords}
                    endpoint={"delete_api"}
                    record_type={apiName}
                    message="This action CANNOT be undone. It will permanently delete the resource and all associated data."
                />

            </div>
        </div>
    )
}

export default MainApi